import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";

import DoorCover from "@/components/DoorCover";
import AudioPlayer from "@/components/AudioPlayer";
import Particles from "@/components/Particles";
import ShareButton from "@/components/ShareButton";

import Hero from "@/sections/Hero";
import Couple from "@/sections/Couple";
import Countdown from "@/sections/Countdown";
import EventDetails from "@/sections/EventDetails";
import LoveStory from "@/sections/LoveStory";
import Rsvp from "@/sections/Rsvp";
import Wishes from "@/sections/Wishes";
import Envelope from "@/sections/Envelope";
import DressCode from "@/sections/DressCode";
import Footer from "@/sections/Footer";

import { WEDDING_DATE } from "@/config";

function App() {
  const [opened, setOpened] = useState(false);

  return (
    <div className="App paper-grain" data-testid="invitation-root">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FDFBF7",
            border: "1px solid rgba(197,160,89,0.4)",
            color: "#2C2A29",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />

      <DoorCover onOpen={() => setOpened(true)} />

      {opened && (
        <>
          <Particles active={opened} />
          <AudioPlayer shouldAutoplay={opened} />
          <ShareButton />

          <main className="relative z-10">
            <Hero weddingDate={WEDDING_DATE} />
            <Couple />
            <Countdown target={WEDDING_DATE} />
            <EventDetails weddingDate={WEDDING_DATE} />
            <LoveStory />
            <Rsvp />
            <Wishes />
            <Envelope />
            <DressCode />
            <Footer />
          </main>
        </>
      )}
    </div>
  );
}

export default App;
